@if (careproviderUnit()) {
  <div
    [id]="'care-provider-' + itemIndex()"
    [ngClass]="{'border-blueberry-3': careproviderUnit().isDigital && !careproviderUnit().isAbroad, 'border-apricot-1': careproviderUnit().isAbroad, 'border-grey-9': !careproviderUnit().isDigital && !careproviderUnit().isAbroad}"
    class="relative rounded-xl bg-white top-container p-4 flex flex-col xl:flex-row justify-between xl:items-stretch gap-4 border"
  >
    <div
      class="flex flex-col w-full xl:w-80 xl:basis-80 h-auto gap-3 border-b border-grey-8 pb-5 xl:pb-0 xl:border-b-0">
      <app-search-careprovider-unit-item-img-v2
        [careproviderRouterLink]="careproviderRouterLink()"
        [class]="'test-img-' + itemIndex()"
        [hasImage]="hasImage()"
        [imageUrl]="imageUrl()"
        [isCustomer]="careproviderUnit()?.isCustomer"
        [isPriorityImage]="isPriorityImage()"
        [itemIndex]="itemIndex()"
        [logoUrl]="logoUrl()"
        [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
        [mainSegment]="mainSegment()"
        [name]="careproviderUnit()?.name"
        [rating]="careproviderUnit()?.rating"
        [reviesCount]="careproviderUnit()?.reviesCount"
        class="w-full xl:w-80 aspect-[314/136]"
      ></app-search-careprovider-unit-item-img-v2>


      <div class="w-full flex flex-col gap-1">
        <div class="line-clamp-1">
          <a
            [class]="'test-title-' + itemIndex()"
            [routerLink]="careproviderRouterLink()"
            class="text-lg xl:text-base font-bold text-grey-0 hover:text-green-1"
          >
            {{ careproviderUnit().name }}
          </a>
        </div>

        <div class="flex flex-row gap-5 justify-start items-center">
          @if (careproviderUnit().address && !careproviderUnit().isDigital && address()) {
            <div class="inline-flex items-center">
              <app-ui-icon
                class="mr-1"
                color="var(--grey-1)"
                name="marker"
                size="sm"
              ></app-ui-icon>
              <a
                (click)="openMap()"
                [class]="'test-address-' + itemIndex()"
                class="text-grey-1 text-sm hover:text-green-1"
              >
                {{ address() }}
              </a>
            </div>
          }

        </div>
      </div>
    </div>
    @if (careService()) {
      <div class="booking-section w-full flex flex-col grow">
        <div class="flex flex-col gap-4">
          <div class="w-full flex flex-col gap-5">
            <div>
              <div class="flex flex-row justify-between items-start flex-wrap 2xl:flex-nowrap mb-0.5 w-full gap-4">
                <a
                  [routerLink]="careService().routerLink"
                  [title]="careService().name"
                >
                  <h2 [innerHtml]="careService().name" class="text-xl font-bold"></h2>
                </a>

                @if (careproviderUnit().isDigital || careproviderUnit().isBoosted || careproviderUnit().isAbroad) {
                  <app-search-careprovider-unit-item-labels
                    [isAbroad]="careproviderUnit().isAbroad"
                    [isBoosted]="careproviderUnit().isBoosted"
                    [isDigital]="careproviderUnit().isDigital"
                    class="block mb-2 2xl:mb-0 order-1 2xl:order-2"
                  ></app-search-careprovider-unit-item-labels>
                }

              </div>
              <div class="text-base text-grey-0 mb-2 line-clamp-1">
                {{ careproviderUnit().suitableFor }}
              </div>
              <div class="text-base text-apricot-2 line-clamp-1">
                {{ careproviderUnit().topPositiveResponse }}
              </div>
            </div>

            <div class="flex justify-stretch items-start lg:items-center lg:justify-start gap-2 flex-col lg:flex-row">
              @if (isInternal()) {
                @if (careService().timeslotDetails?.length > 0) {
                  <div class="flex flex-row items-start justify-start gap-2 w-full lg:w-auto">
                    @for (timeslot of careService().timeslotDetails; let j = $index; track timeslot.label) {
                      <app-timeslot-button
                        [class]="'md:inline test-timeslot-' + j"
                        [eventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN"
                        [eventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                        [eventLabel]="careService().id.toString()"
                        [eventParams]="generateDataLayerParamsClickGA4(
                    eventCategoryEnum.VARDEN_BOOKING +
                      ' - ' +
                      eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN,
                    careService(),
                    0
                  )"
                        [ngClass]="{'hidden' : j > 2, 'sm:inline': j < 5, 'lg:hidden': j >= 5}"
                        [timeslot]="timeslot"
                        appGtmEvent
                        appGtmGa4Event
                      ></app-timeslot-button>
                    }
                  </div>
                } @else {
                  <div class="text-base text-apricot-2 font-medium">
                    Inga lediga tider den närmaste månaden
                  </div>
                }

              } @else {
                @for (config of careService().bookingConfigurationData; track config.id) {
                  <app-booking-btn
                    [bookingConfigurationData]="config"
                    [caregiverContactInfo]="careproviderUnit().caregiverContactInfo"
                    [class]="'booking-btn'"
                    [gaEventAction]="
                      eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
                    "
                    [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                    [gaEventLabel]="careService().id.toString()"
                    [index]="0"
                    [mainCaregiverUnitType]="careproviderUnit().mainCaregiverUnitType"
                    [pageType]="pageType()"
                    class="grow lg:grow-0 block w-full lg:w-auto lg:inline-block"
                  ></app-booking-btn>
                }
              }

            </div>

            <div class="flex flex-row justify-between">
              @if (isInternal()) {
                @for (config of careService().bookingConfigurationData; track config.id) {
                  <app-booking-btn
                    [bookingConfigurationData]="config"
                    [caregiverContactInfo]="careproviderUnit().caregiverContactInfo"
                    [class]="'text-duck-blue-2 underline text-base booking-btn test-booking-btn'"
                    [gaEventAction]="
                        eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
                      "
                    [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                    [gaEventLabel]="careService().id.toString()"
                    [hasTimeslots]="careService().timeslotDetails.length > 0"
                    [index]="0"
                    [isJustLink]="true"
                    [label]="'Se alla tillgängliga tider'"
                    [mainCaregiverUnitType]="careproviderUnit().mainCaregiverUnitType"
                    [pageType]="pageType()"
                  ></app-booking-btn>
                }
              } @else {
                <div></div>
              }


              @if (careService().price > 0) {
                <div class="flex justify-start items-center gap-1 text-apricot-2 text-lg font-bold">
                  <span *ngIf="careService().isFromPrice">fr.</span>
                  <span>{{ careService().price }} kr</span>
                  <app-ui-icon
                    #tooltip="matTooltip"
                    (click)="tooltip.show()"
                    *ngIf="careService().priceDescription"
                    color="var(--grey-1)" matTooltip="{{ careService().priceDescription }}"
                    matTooltipClass="varden-tooltip"
                    matTooltipPosition="above"
                    name="info"
                    size="md"></app-ui-icon>
                </div>
              }

              @if ((careService().price === 0 || careService().price === null) && careService().priceDescription) {
                <div class="text-grey-1 text-base">
                  {{ careService().priceDescription }}
                </div>
              }
            </div>

          </div>
        </div>
      </div>
    }
  </div>
}

